import {
  NDCBulkEditFormFieldsTypes,
  NDCFormFieldsTypes,
} from 'Interfaces/FactsInterfaces/drugInterfaces';
import LockIcon from 'assets/icons/lockIcon.svg';
import MinusIcon from 'assets/icons/minusIcon.svg';
import { observer } from 'mobx-react';
import { Button } from 'primereact/button';
import { Calendar } from 'primereact/calendar';
import { Dialog } from 'primereact/dialog';
import { Divider } from 'primereact/divider';
import { Dropdown } from 'primereact/dropdown';
import {
  getFirstDayOfMonth,
  getNextMonthFirstDay,
  getOneBiggerDate,
  getOneSmallerDate,
  getTomorowsDate,
  DateConversionUtility,
} from 'utils/dateUtilities';
import { checkIfNDCStrategyAddEnabled } from 'utils/facts/roleBasedFunctionalityAccess';
import classes from './bulkEditModa.module.scss';
import { useBultEditModal } from './useBulkEditModal';

const NdcBultEditModal = ({
  visibility,
  toggleVisibility,
}: {
  visibility: boolean;
  toggleVisibility: () => void;
}) => {
  const {
    ndcStrategyIndividualEditData,
    isAnyStrategySelected,
    initialNdcStrategyIndividualEditData,
    handleStrategySelect,
    handleUnselectStrategy,
    allDropdownOptions,
    errorDetails,
    formUpdateMethods,
    isNdcUpdating,
    formFieldsArrayConverter,
    maxDateFromGivenAndTodays,
    isUpdateDisable,
    dropDownSelectedOption,
    allFieldsOptions,
    isHistoryLoading,
    userModulesRoles,
    checkIfDropdownOptionDisabled,
  } = useBultEditModal();

  const DropDownItemTemplate = (option: { name: string; code: string }) => {
    return (
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <div style={{ marginRight: '0.6rem' }}>{option.name}</div>
        {!checkIfNDCStrategyAddEnabled(
          option.code as NDCFormFieldsTypes,
          userModulesRoles.facts,
          userModulesRoles
        ) && (
          <img
            src={LockIcon}
            alt={'Locked'}
            style={{ height: '17px', width: '17px', padding: 0 }}
          />
        )}
      </div>
    );
  };

  return (
    <Dialog
      blockScroll
      resizable={false}
      draggable={false}
      header="Bulk Add"
      headerClassName={classes.modalHeader}
      visible={visibility}
      style={{ width: '50vw' }}
      onHide={() => {
        if (!visibility) return;
        toggleVisibility();
      }}
    >
      <div className={classes.modalContainer}>
        <Divider className={classes.devider} />
        <div className={classes.updateTooltip}>
          <span className={classes.spanToolTip}>
            * Fields for which start date is in future, will only be visible in future
          </span>
          <Dropdown
            options={allDropdownOptions()}
            optionLabel="name"
            optionDisabled={checkIfDropdownOptionDisabled}
            itemTemplate={DropDownItemTemplate}
            onChange={e => {
              handleStrategySelect(e.target.value.code);
            }}
            placeholder="Select strategy"
          />
        </div>
        {ndcStrategyIndividualEditData && initialNdcStrategyIndividualEditData && (
          <>
            {isAnyStrategySelected() ? (
              <>
                {formFieldsArrayConverter().map((fieldValues, index) => {
                  return (
                    <div
                      style={{
                        display: 'flex',
                        flexDirection: 'column',
                        gap: '2rem',
                      }}
                    >
                      {fieldValues.selected && fieldValues.keyName !== 'PPSSC' ? (
                        <div
                          style={{
                            display: 'flex',
                            flexDirection: 'column',
                            gap: '0.5rem',
                            width: '100%',
                          }}
                        >
                          <div
                            style={{
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'space-between',
                            }}
                          >
                            <span>
                              {fieldValues.keyName === 'PPS'
                                ? 'PPS & PPS Reason'
                                : fieldValues.keyName === 'DPStrategy'
                                  ? 'Demand Planning'
                                  : 'Financial Segmentation'}
                            </span>
                            <img
                              style={{ cursor: 'pointer' }}
                              src={MinusIcon}
                              alt="Remove"
                              onClick={() => handleUnselectStrategy(fieldValues.keyName)}
                            />
                          </div>
                          <div
                            style={{
                              display: 'flex',
                              gap: '1rem',
                              width: '100%',
                            }}
                          >
                            <div style={{ width: '50%' }}>
                              <div
                                style={{
                                  display: 'flex',
                                  width: '100%',
                                  gap: '0.5rem',
                                }}
                                className={classes.valuesContainer}
                              >
                                <Dropdown
                                  style={{ width: '100%' }}
                                  key={index}
                                  optionLabel="name"
                                  value={dropDownSelectedOption(
                                    fieldValues.keyName,
                                    fieldValues.value
                                  )}
                                  options={
                                    allFieldsOptions ? allFieldsOptions[fieldValues.keyName] : []
                                  }
                                  onChange={e =>
                                    formUpdateMethods.handleUpdateValue(
                                      fieldValues.keyName as NDCBulkEditFormFieldsTypes,
                                      e.target.value.code
                                    )
                                  }
                                  placeholder="Select strategy"
                                />
                              </div>
                            </div>
                            <div style={{ width: '50%' }}>
                              {fieldValues.keyName === 'PPS' && (
                                <div
                                  style={{
                                    display: 'flex',
                                    width: '100%',
                                    gap: '0.5rem',
                                  }}
                                  className={classes.valuesContainer}
                                >
                                  <Dropdown
                                    style={{ width: '100%' }}
                                    key={index}
                                    value={dropDownSelectedOption(
                                      'PPSSC',
                                      ndcStrategyIndividualEditData.PPSSC.value
                                    )}
                                    options={allFieldsOptions ? allFieldsOptions.PPSSC : []}
                                    optionLabel="name"
                                    onChange={e =>
                                      formUpdateMethods.handleUpdateValue(
                                        'PPSSC' as NDCBulkEditFormFieldsTypes,
                                        e.target.value.code
                                      )
                                    }
                                    placeholder="Select strategy"
                                  />
                                </div>
                              )}
                            </div>
                          </div>
                          <div
                            style={{
                              display: 'flex',
                              alignItems: 'center',
                              gap: '1rem',
                            }}
                          >
                            {/* Start date */}
                            <div style={{ width: '100%' }}>
                              {fieldValues.monthYearDates && (
                                <Calendar
                                  style={{ width: '100%' }}
                                  view="month"
                                  dateFormat="mm/yy"
                                  className={classes.dateInput}
                                  minDate={getNextMonthFirstDay(new Date().toDateString())}
                                  maxDate={
                                    ndcStrategyIndividualEditData[fieldValues.keyName].endDate ===
                                    initialNdcStrategyIndividualEditData[fieldValues.keyName]
                                      .endDate
                                      ? undefined
                                      : getFirstDayOfMonth(
                                          new Date(
                                            ndcStrategyIndividualEditData[
                                              fieldValues.keyName
                                            ].endDate
                                          ).toDateString()
                                        )
                                  }
                                  onChange={e =>
                                    formUpdateMethods.handleUpdateStartDate(
                                      fieldValues.keyName,
                                      e.target.value as Date
                                    )
                                  }
                                  value={DateConversionUtility.convertDBDateToLocal(
                                    ndcStrategyIndividualEditData[fieldValues.keyName].startDate
                                  )}
                                  disabled={fieldValues.datesDisabled ? true : false}
                                  showIcon
                                />
                              )}
                              {!fieldValues.monthYearDates && (
                                <Calendar
                                  style={{ width: '100%' }}
                                  className={classes.dateInput}
                                  // min and max dates code is sensitive please change it carefully, and test itt thoroughly after changing
                                  minDate={getTomorowsDate()}
                                  maxDate={
                                    ndcStrategyIndividualEditData[fieldValues.keyName].endDate ===
                                    initialNdcStrategyIndividualEditData[fieldValues.keyName]
                                      .endDate
                                      ? undefined
                                      : getOneSmallerDate(
                                          DateConversionUtility.convertDBDateToLocal(
                                            ndcStrategyIndividualEditData[fieldValues.keyName]
                                              .endDate
                                          )!
                                        )
                                  }
                                  onChange={e =>
                                    formUpdateMethods.handleUpdateStartDate(
                                      fieldValues.keyName,
                                      e.target.value as Date
                                    )
                                  }
                                  value={DateConversionUtility.convertDBDateToLocal(
                                    ndcStrategyIndividualEditData[fieldValues.keyName].startDate
                                  )}
                                  disabled={fieldValues.datesDisabled ? true : false}
                                  showIcon
                                />
                              )}
                            </div>

                            {/* End Date */}
                            <div style={{ width: '100%' }}>
                              {fieldValues.monthYearDates && (
                                <Calendar
                                  style={{ width: '100%' }}
                                  view="month"
                                  dateFormat="mm/yy"
                                  className={classes.dateInput}
                                  minDate={
                                    ndcStrategyIndividualEditData[fieldValues.keyName].startDate
                                      ? getOneBiggerDate(
                                          maxDateFromGivenAndTodays(
                                            new Date(
                                              ndcStrategyIndividualEditData[
                                                fieldValues.keyName
                                              ].startDate
                                            )
                                          )
                                        )
                                      : getTomorowsDate()
                                  }
                                  onChange={e =>
                                    formUpdateMethods.handleUpdateEndDate(
                                      fieldValues.keyName,
                                      e.target.value as Date
                                    )
                                  }
                                  value={DateConversionUtility.convertDBDateToLocal(
                                    ndcStrategyIndividualEditData[fieldValues.keyName].endDate
                                  )}
                                  disabled={fieldValues.datesDisabled ? true : false}
                                  showIcon
                                />
                              )}
                              {!fieldValues.monthYearDates && (
                                <Calendar
                                  style={{ width: '100%' }}
                                  className={classes.dateInput}
                                  minDate={
                                    ndcStrategyIndividualEditData[fieldValues.keyName].startDate
                                      ? getOneBiggerDate(
                                          maxDateFromGivenAndTodays(
                                            DateConversionUtility.convertDBDateToLocal(
                                              ndcStrategyIndividualEditData[fieldValues.keyName]
                                                .startDate
                                            )!
                                          )
                                        )
                                      : getTomorowsDate()
                                  }
                                  onChange={e =>
                                    formUpdateMethods.handleUpdateEndDate(
                                      fieldValues.keyName,
                                      e.target.value as Date
                                    )
                                  }
                                  value={DateConversionUtility.convertDBDateToLocal(
                                    ndcStrategyIndividualEditData[fieldValues.keyName].endDate
                                  )}
                                  disabled={fieldValues.datesDisabled ? true : false}
                                  showIcon
                                />
                              )}
                            </div>
                          </div>
                        </div>
                      ) : (
                        <></>
                      )}
                    </div>
                  );
                })}
              </>
            ) : (
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  padding: '3rem',
                  width: '100%',
                  border: '1px solid grey',
                  borderRadius: '0.3rem',
                }}
              >
                <span>Please select some strategy to Bulk Add</span>
              </div>
            )}
          </>
        )}

        {errorDetails.isError && (
          <div className={classes.errorDetails}>{`* ${errorDetails.errorDetails}`}</div>
        )}
        <div className={classes.updateButtonWrapper}>
          <div></div>
          <Button
            disabled={
              !isAnyStrategySelected() || isUpdateDisable() || isNdcUpdating || isHistoryLoading
            }
            loading={isNdcUpdating || isHistoryLoading}
            onClick={formUpdateMethods.handleUpdateButtonClick}
            className={classes.updateButton}
          >
            Update
          </Button>
        </div>
      </div>
    </Dialog>
  );
};

export default observer(NdcBultEditModal);
